import { Component, computed, inject, input } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';

import { IconComponent } from '@shared/components/icon/icon.component';
import { MessagesConstants } from '@shared/constants/messages.constants';
import { TooltipDirective } from '@shared/directives/tooltip.directive';
import { Currency } from '@shared/services/gql.service';
import { GlobalStore } from '@shared/store/global/global.store';
import { InvoiceModel } from '@shared/store/invoice/invoice.model';
import { decimalEquality } from '@shared/utils';
import { Utils } from '@shared/utils/utils';

import { MapActivitiesTotals } from '../map-activities-modal.model';

@Component({
  imports: [IconComponent, NgSelectModule, TooltipDirective],
  selector: 'aux-map-activities-modal-total-row',
  templateUrl: 'map-activities-modal-total-row.component.html',
})
export class MapActivitiesModalTotalRowComponent {
  private globalStore = inject(GlobalStore);

  invoice = input.required<InvoiceModel>();

  private getTotal = (total_value: number, currency: Currency) => {
    const hasPrimaryAttribute = !!this.globalStore.primaryAttribute()?.attribute_name;

    return hasPrimaryAttribute
      ? Utils.zeroHyphen
      : Utils.currencyFormatter(total_value, {}, currency);
  };

  discountTotal = computed(() => {
    const invoice = this.invoice();

    return this.getTotal(
      invoice.expense_amounts.discount_total.value,
      invoice.organization.currency
    );
  });
  investigatorTotal = computed(() => {
    const invoice = this.invoice();

    return this.getTotal(
      invoice.expense_amounts.investigator_total.value,
      invoice.organization.currency
    );
  });
  serviceTotal = computed(() => {
    const invoice = this.invoice();

    return this.getTotal(
      invoice.expense_amounts.services_total.value,
      invoice.organization.currency
    );
  });
  thruTotal = computed(() => {
    const invoice = this.invoice();

    return this.getTotal(
      invoice.expense_amounts.pass_thru_total.value,
      invoice.organization.currency
    );
  });

  totals = input.required<MapActivitiesTotals>();

  protected decimalEquality = decimalEquality;
  readonly messagesConstants = MessagesConstants;
  protected readonly utils = Utils;
}
